<template>
  <embedded-crud-table
    :entity="entity"
    :entity-store="entityStore"
    :columns="columns"
    :generate-summary="generateSummary"
    :definition="definition"
    :caption="caption"
    :disabled="disabled"
    :parent-id-filter-field="parentIdFilterField"
    :open-in-fullscreen="openInFullscreen"
    :required="required"
    :create-item-from-form-data="createItemFromFormData"
    :create-form-data-from-item="createFormDataFromItem"
    :permission-code="permissionCode"
    :parent-i-d="parentID"
  />
</template>

<script>
import EmbeddedCrudTable from '@/components/crud/EmbeddedCrudTable';
import formMixin from './linkstorecollections/form-mixin';

export default {
  components: {
    EmbeddedCrudTable
  },
  mixins: [formMixin],
  props: {
    caption: String,
    parentIdFilterField: {
      type: String,
      required: true
    },
    permissionCode: String,
    disabled: {
      default: false,
      type: Boolean
    },
    columns: {
      default: () => [
        {
          field: 'collectionDescription',
          label: 'store.collection',
          filter: { type: 'none' },
          sortable: false
        }
      ],
      type: Array
    },
    openInFullscreen: {
      default: false,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    },
    parentID: Number,
    domainID: {
      default: 0,
      type: Number
    }
  },
  watch: {
    domainID() {
      this.refresh();
    }
  },
  created() {
    if (this.domainID > 0) {
      this.refresh();
    }
  },
  methods: {
    generateSummary(row) {
      let summary = `${row.name}`;
      if (row.jobFunction) {
        summary += ` (${row.jobFunction})`;
      }
      return summary;
    },
    refresh() {
      this.$store.dispatch('collection/getItems', {
        query: { domainID: +this.domainID }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
